import React from "react";
import Key from "../../util/Key";
import { useForm } from "react-hook-form";
import Input from "../inputs/Input";
import Select from "../inputs/Select";
import TextArea from "../inputs/TextArea";

const Preview = ({ dataInput, setEditableInput, setItemEditable }) => {
    const {
        register,
        formState: { errors },
    } = useForm();

    return (
        <div className="">
            {dataInput.length > 0 && (
                <form className="border-none rounded-3">
                    <div className="row mb-3 mt-3 d-flex justify-content-center">
                        <div className="col-12 text-center">
                            <h1>Vista Previa</h1>
                        </div>
                        {dataInput.map((item) => {
                            switch (item.data.type) {
                                case "input":
                                    return (
                                        <div
                                            className={
                                                item.data.size == "0"
                                                    ? "col-sm-6 col-12 mb-3"
                                                    : "col-12 mb-3"
                                            }
                                            key={Key()}
                                            onClick={() => {
                                                setEditableInput(true);
                                                setItemEditable(item.data);
                                            }}
                                        >
                                            <Input
                                                input={item.data}
                                                register={register}
                                                errors={errors}
                                            />
                                        </div>
                                    );
                                case "text_area":
                                    return (
                                        <div
                                            className={
                                                item.data.size == "0"
                                                    ? "col-sm-6 col-12 mb-3"
                                                    : "col-12 mb-3"
                                            }
                                            key={Key()}
                                            onClick={() => {
                                                setEditableInput(true);
                                                setItemEditable(item.data);
                                            }}
                                        >
                                            <TextArea
                                                key={Key()}
                                                input={item.data}
                                                register={register}
                                                errors={errors}
                                            />
                                        </div>
                                    );
                                case "select":
                                    return (
                                        <div
                                            className={
                                                item.data.size == "0"
                                                    ? "col-sm-6 col-12 mb-3"
                                                    : "col-12 mb-3"
                                            }
                                            key={Key()}
                                            onClick={() => {
                                                setEditableInput(true);
                                                setItemEditable(item.data);
                                            }}
                                        >
                                            <Select
                                                key={Key()}
                                                input={item.data}
                                                register={register}
                                                errors={errors}
                                            />
                                        </div>
                                    );
                                default:
                                    return <h1>nada</h1>;
                            }
                        })}
                    </div>
                </form>
            )}
        </div>
    );
};

export default Preview;
